import { render, staticRenderFns } from "./ListCollectionRequests.vue?vue&type=template&id=3b42c66d&scoped=true&"
import script from "./ListCollectionRequests.vue?vue&type=script&lang=ts&"
export * from "./ListCollectionRequests.vue?vue&type=script&lang=ts&"
import style0 from "./ListCollectionRequests.vue?vue&type=style&index=0&id=3b42c66d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b42c66d",
  null
  
)

export default component.exports